<template>
    <div class="dialog-wrap">
      <el-button class="history-btn" @click="showDialog" size="small"
        >导出历史</el-button
      >
      <!-- 批量导出历史 -->
      <el-dialog
        title="批量导出历史"
        :visible.sync="dialogVisible"
        width="1000px"
      >
        <!-- <Search
          ref="search"
          class="my-search"
          :searchConfig="tableConfigExport"
          @doSearch="doSearch"
        >
        </Search> -->
        <!-- 列表 -->
        <Table
          ref="tableExport"
          class="table-wrap"
          :tableConfig="tableConfigExport"
        >
          <template :slot="'templateCode'" slot-scope="scope">
            {{ scope.row.templateName }}
          </template>
          <template :slot="'statusIn'" slot-scope="scope">
            {{ scope.row.status | getStatus }}
          </template>
          <template :slot="'result'" slot-scope="scope">
            <el-button
              type="text"
              @click="() => showResult(scope.row)"
              v-if="scope.row.status === '3'"
              >查看结果</el-button
            >
            <span v-else> {{ scope.row.status === "2" ? "成功" : "-" }} </span>
          </template>
          <template :slot="'downloadUrl'" slot-scope="scope">
            <el-link
              type="success"
              v-if="scope.row.downloadUrl"
              :href="scope.row.downloadUrl"
              target="_blank"
              >下载</el-link
            >
          </template>
        </Table>
      </el-dialog>
      <el-dialog
        title="错误信息"
        :visible.sync="errorDialogVisible"
        width="1000px"
        append-to-body
      >
        <pre style="white-space: pre-wrap; max-height: 500px; overflow: auto">{{
          errorInfo
        }}</pre>
        <span slot="footer" class="dialog-footer">
          <el-button @click="errorDialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </template>

<script>
// import Search from '@/components/search/index'
import Table from '@/components/table/index'
// import { shortcuts } from '@/utils/shortcuts'
const options = [
  {
    value: '等待中',
    code: '0'
  },
  {
    value: '进行中',
    code: '1'
  },
  {
    value: '成功',
    code: '2'
  },
  {
    value: '失败',
    code: '3'
  }
]

export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    setPermission: {
      type: Function,
      default: null
    }
  },
  filters: {
    getStatus (val) {
      let str = ''
      options.some((v) => {
        if (v.code === val) {
          str = v.value
          return true
        }
        return false
      })
      return str || val
    }
  },
  components: {
    Table
    // Search
  },
  data () {
    return {
      dialogVisible: false,
      errorDialogVisible: false,
      errorInfo: '',
      tableConfigExport: {
        searchUrl: '/front/oms/shopping/thirdpurchaseorder/v1/thirdPurchaseOrderListExportHistory', // 搜索接口
        searchMethod: 'POST', // 接口请求方式
        autoSearch: false, // 是否需要默认查询
        searchType: 'restpage', // 搜索类型
        needPagination: true, // 是否需要分页
        resultListName: 'records',
        count: 'total',
        hideLabel: true, // 搜索隐藏label
        maxHeight: '400px',
        params: [
          {
            prop: 'templateCode',
            label: '导出类型',
            width: '136px',
            placeholder: '导出类型',
            searchType: 'tabSelect',
            props: {
              label: 'value',
              value: 'code'
            },
            isSlot: true,
            options: []
          },
          {
            prop: 'statusIn',
            label: '任务状态',
            hideInSearch: true,
            isSlot: true,
            props: {
              label: 'value',
              value: 'code'
            },
            options
          },
          {
            prop: 'createTime',
            label: '任务提交时间',
            width: '160px',
            columnsType: 'date',
            sortable: true,
            hideInSearch: true
          },
          {
            prop: 'startTime',
            label: '任务执行时间',
            width: '160px',
            hideInSearch: true
          },
          {
            prop: 'endTime',
            label: '任务完成时间',
            width: '160px',
            hideInSearch: true
          },
          {
            prop: 'result',
            label: '结果信息',
            hideInSearch: true,
            isSlot: true
          },
          // {
          //   prop: 'createUserName',
          //   label: '操作人',
          //   placeholder: '操作人'
          // },
          {
            prop: 'downloadUrl',
            label: '操作',
            hideInSearch: true,
            isSlot: true
          }
        ],
        extra: {
          // 额外参数
        }
      }
    }
  },
  created () {
    if (this.url) {
      this.tableConfigExport.searchUrl = this.url
    }
  },
  mounted () {
  },
  methods: {
    // 查看导出历史
    showDialog () {
      this.dialogVisible = true
      setTimeout(() => {
        this.doSearch()
      }, 100)
    },
    // 查看结果
    showResult (row) {
      this.$http
        .get(`/help/export-log-mgmt/v1/sys-exports/${row.id}/exception-stack`)
        .then(({ data: res }) => {
          console.log(res)
          this.errorInfo = res.data
          this.errorDialogVisible = true
        })
    },
    // 查询
    doSearch (input) {
      if (input) {
        this.tableConfigExport.extra = {
          ...input
        }
      }
      this.$refs.tableExport.clearSort()
      this.$refs.tableExport.getList()
    }
  }
}
</script>

  <style lang="scss" scoped>
  .dialog-wrap {
    display: inline-block;
    .history-btn {
      margin-left: 6px;
    }
  }
  .my-search {
    ::v-deep .search-list .item {
      width: 40%;
      &.search-btns {
        width: 20%;
      }
    }
  }
  </style>
